// ShopServices.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiPlus, FiEdit, FiTrash2, FiX } from 'react-icons/fi';

export function ShopServices() {
  const [services, setServices] = useState([]);
  const [shopType, setShopType] = useState('barber');
  const svcHint = shopType === 'parlour' ? 'e.g. Facial, Waxing, Makeup' : shopType === 'dentist' ? 'e.g. Checkup, Filling, Scaling' : 'e.g. Haircut, Shave, Facial';
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', price: '', duration_minutes: 30, is_active: true, sort_order: 0 });
  const [editId, setEditId] = useState(null);
  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  const load = () => axios.get('/api/shop/services').then(r => setServices(r.data));
  useEffect(() => { axios.get('/api/shop/profile').then(r => { if (r.data.shop_type) setShopType(r.data.shop_type); }).catch(() => {}); }, []);
  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm({ name: '', description: '', price: '', duration_minutes: 30, is_active: true, sort_order: 0 }); setEditId(null); setModal(true); };
  const openEdit = (s) => { setForm({...s, is_active: !!s.is_active}); setEditId(s.id); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await axios.put(`/api/shop/services/${editId}`, form); toast.success('Service update ho gayi!'); }
      else { await axios.post('/api/shop/services', form); toast.success('Service add ho gayi!'); }
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete karna chahte hain?')) return;
    try { await axios.delete(`/api/shop/services/${id}`); toast.success('Deleted!'); load(); }
    catch { toast.error('Error'); }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex-between page-header">
          <div><h1>Services</h1><p>Apni shop ki services aur prices set karein</p></div>
          <button className="btn btn-primary" onClick={openAdd}><FiPlus /> Nai Service</button>
        </div>
        <div className="card">
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Service</th><th>Price</th><th>Duration</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {services.map(s => (
                  <tr key={s.id}>
                    <td><div style={{ fontWeight: 600 }}>{s.name}</div><div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{s.description}</div></td>
                    <td style={{ fontWeight: 700, color: 'var(--success)' }}>PKR {Number(s.price).toLocaleString()}</td>
                    <td>{s.duration_minutes} min</td>
                    <td><span className={`badge ${s.is_active ? 'badge-success' : 'badge-danger'}`}>{s.is_active ? 'Active' : 'Inactive'}</span></td>
                    <td><div className="flex gap-2">
                      <button className="btn btn-outline btn-sm" onClick={() => openEdit(s)}><FiEdit /></button>
                      <button className="btn btn-danger btn-sm" onClick={() => del(s.id)}><FiTrash2 /></button>
                    </div></td>
                  </tr>
                ))}
                {services.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', padding: '40px', color: '#999' }}>Koi service nahi — Upar se add karein</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {modal && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
            <div className="modal">
              <div className="modal-header"><h3>{editId ? 'Service Edit' : 'Nai Service'}</h3><button className="modal-close" onClick={() => setModal(false)}><FiX /></button></div>
              <form onSubmit={handleSave}>
                <div className="form-group"><label className="form-label">Service Name *</label><input className="form-control" value={form.name} onChange={e => set('name', e.target.value)} placeholder={svcHint} required /></div>
                <div className="form-group"><label className="form-label">Description</label><textarea className="form-control" rows={2} value={form.description} onChange={e => set('description', e.target.value)} /></div>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Price (PKR) *</label><input type="number" className="form-control" value={form.price} onChange={e => set('price', e.target.value)} required /></div>
                  <div className="form-group"><label className="form-label">Duration (minutes)</label><input type="number" className="form-control" value={form.duration_minutes} onChange={e => set('duration_minutes', e.target.value)} /></div>
                </div>
                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={form.is_active} onChange={e => set('is_active', e.target.checked)} />
                    <span className="form-label" style={{ margin: 0 }}>Active (customers ko dikhe)</span>
                  </label>
                </div>
                <button className="btn btn-primary btn-full" type="submit">{editId ? '💾 Update' : '✅ Add Service'}</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ShopServices;
